import React, { useState, useEffect } from 'react';
import Input from '../Input';
import PasswordInput from '../PasswordInput';
import Modal from '../Modal';
import { useConfirm } from '../ConfirmContext';
import * as validation from '../Validation';

const ExtraUserModal = ({extraUser, extraUsers, setVisible, saveExtraUser}) => {
  const confirm = useConfirm();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (extraUser) {
      setEmail(extraUser.email);
      setTitle(extraUser ? extraUser.email : 'Add Extra User');
    }
  }, [extraUser]);

  return (
    <Modal isOpen={true}
           zIndex={200}>
      <div style={{
             background: 'linear-gradient(gray, transparent)',
             position: 'absolute',
             transform: 'translate(-50%, -50%)',
             top: '50%',
             left: '50%',
             width: '600px',
             borderRadius: '10px',
           }}>
        <div
          style={{
            margin: '1px',
            borderRadius: '10px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            padding: '20px',
            backgroundColor: 'black',
          }}>
          <div style={{
                 display: 'flex',
                 flexDirection: 'column',
                 alignItems: 'center',
                 justifyContent: 'space-between',
                 width: '100%',
               }}>
            <span style={{fontSize: '22px',
                          fontWeight: 'bold',
                         }}>
              {title}
            </span>

            <Input label='EMAIL'
                   value={email}
                   onChange={(e) => setEmail(e.target.value)} />

            <PasswordInput label='PASSWORD'
                           onChange={(e) => setPassword(e.target.value)}
                           showWarning={true}/>

            <PasswordInput label='CONFIRM PASSWORD'
                           target={password}
                           onChange={(e) => setConfirmPassword(e.target.value)}
                           showWarning={true}/>

            <div style={{display: 'flex',
                         flexDirection: 'row',
                         alignItems: 'center',
                         marginTop: '10px',
                         gap: '10px',
                         justifyContent: 'center',
                        }}>
              <div style={{alignItems: 'center',
                           padding: '10px 20px',
                           border: '1px solid #e0e0e0',
                           borderRadius: '5px',
                           cursor: 'pointer',
                           fontWeight: 'bold',
                           alignSelf: 'flex-end',
                           display: 'flex',
                           justifyContent: 'center',
                          }}
                   onClick={() => setVisible(false)}>
                Cancel
              </div>
              <div style={{alignItems: 'center',
                           padding: '10px 20px',
                           backgroundColor: '#009de6',
                           color: 'white',
                           borderRadius: '5px',
                           cursor: 'pointer',
                           fontWeight: 'bold',
                           alignSelf: 'flex-end',
                           display: 'flex',
                           justifyContent: 'center',
                          }}
                   onClick={async () => {
                     if (validation.getEmailWarning(email)) {
                       await confirm('Please enter a valid email address', true);
                       return;
                     }
                     if (validation.getPasswordWarning(password, null)) {
                       await confirm('Please enter a valid password', true);
                       return;
                     }
                     if (validation.getPasswordWarning(confirmPassword, password)) {
                       await confirm('Please confirm your password correctly', true);
                       return;
                     }

                     let emails = extraUsers.map((user) => user.email);

                     if (extraUser === null && emails.includes(email)) {
                       await confirm('This email is already in use', true);
                       return;
                     }

                     if (extraUser === null && password === '') {
                       await confirm('Please enter a password', true);
                       return;
                     }

                     saveExtraUser({
                       email: email,
                       password: password,
                     });

                     setVisible(false);
                   }}>
                {extraUser ? 'Save' : 'Add'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ExtraUserModal;
